/* eslint-env browser */
/* eslint max-statements: [2, 10], max-depth: [2, 4], max-params: [2, 3], max-nested-callbacks: [2, 2], complexity: [2, 4] */

// TBC how the dynamic loading works for a modal

var notices = require('../../notices')
var request = require('../../request')
var modal = require('../modal-static')
var menuHover = require('../../menu')
var raygun = require('../../raygun');

// Ensure only one request at a time being process at anytime
var activeRequest = false
var activeRequestURL = ''

// TBC Following modules
//var ui = require('../../photo-upload-ui')
//var spinner = require('./spinner').spinner

// Given there is an ajax call
// When the call is started
// Then show the spinner

var onloadstartHandler = function () {
  //ui.overlay && (ui.overlay.hidden = true)
  //spinner.hidden = false
  console.log("Show spinner")
}

// TBC
// Given there is an ajax call in progress
// When there is a progress event
// Then update the textContent in the progressbar

var onprogressHandler = function (e) {
  console.log("Show spinner" + (e.loaded / e.total * 100 >> 0))
}

// TBC
// Given there is an ajax call
// When the call is completed
// Then hide the progressbar

var onloadendHandler = function () {
  console.log("Hide spinner")
}

// When the response status is not 200 (success)
// Then display an error notice
var reject = function () {
  notices.warn()
  modal.destroy()
}

// Given the URL for the modal
// When the URL returns a response containing a modal
// Then display the modal

// Given the URL for the modal
// When the fails
// Then display an error notice

var resolve = function (res) {
  activeRequest = false
  var content = new DOMParser().parseFromString(res, 'text/html')
  if (content) {
    var dynamicModal = content.getElementById('modal')
    if (dynamicModal) {
      // Create a DOM element in the correct context
      modal.set(document.createRange().createContextualFragment(dynamicModal.innerHTML))
      var ev = new Event('cm-modal-loaded', { bubbles: true })
      ev.modalLoadingURL = activeRequestURL
      document.dispatchEvent(ev)
      activeRequestURL = ''
    }
  }
}

var errorHandling = function (e) {
  activeRequest = false
  activeRequestURL = ''
  notices.warn(e)
}

function load(url) {
  activeRequest = true
  activeRequestURL = url
  request.get(url, {onloadstartHandler:onloadstartHandler, onprogressHandler:onprogressHandler})
    .then(function (res) {
      onloadendHandler()
      return res
    })
    .then(function (res) {
      res.modalLoadingURL = url
      resolve(res)
    })
    .catch(function (err) {
      raygun.sendError(err, 'modalDynamicLoad');
      errorHandling(err)
    })
}

function show(ev) {
  var target = ev.target.closest('[data-cm-modal-url]')
  if (target && !activeRequest) {
    // ev.preventDefault()
    ev.stopImmediatePropagation()
    menuHover.resetHover();
    var dynamicModal = target.dataset.cmModalUrl;
    if (dynamicModal) {
      load(dynamicModal)
      showOnce(target)
    }
  }
}

function showOnce(item) {
  var hasShowOnce = item.dataset.showOnce
  if (hasShowOnce) {
    // links to same modal
    var otherLinks = document.querySelectorAll('[data-show-once="'+hasShowOnce+'"]')
    if (otherLinks) {
      Array.from(otherLinks).forEach(function (otherLink) {
        otherLink.removeAttribute('data-cm-modal-url')
      })
    }
  }
  
}

function requestModal(ev) {
  var dynamicModal = ev.cmModalUrl;
  if (dynamicModal && !activeRequest) {
    ev.stopImmediatePropagation()
    load(dynamicModal)
  }
}

document.addEventListener('click', show)
document.addEventListener('cm-modal-load', requestModal, true)
